export const OFFERING_KIND = {
  BOOKING_TYPE: 'BOOKING_TYPE',
  LESSON_PACK: 'LESSON_PACK',
  VIRTUAL_COACHING: 'VIRTUAL_COACHING',
}

export const VIRTUAL_COACHING_CATEGORY = 'SWING_EVALUATION'

export const getOfferingKind = bookingType => {
  if (bookingType?.offeringKind === OFFERING_KIND.VIRTUAL_COACHING) {
    return OFFERING_KIND.VIRTUAL_COACHING
  }
  if (bookingType?.lessonPacks?.length > 0) {
    return OFFERING_KIND.LESSON_PACK
  }
  return OFFERING_KIND.BOOKING_TYPE
}

export const isVirtualCoaching = bookingType =>
  getOfferingKind(bookingType) === OFFERING_KIND.VIRTUAL_COACHING

export const TURNAROUND_HOURS_OPTIONS = [
  { label: '24 hours', value: 24 },
  { label: '48 hours', value: 48 },
  { label: '72 hours', value: 72 },
  { label: '1 week', value: 168 },
]

export const DEFAULT_TURNAROUND_HOURS = 72

export const PURCHASE_LIMIT_PERIOD_OPTIONS = [
  { label: 'per week', value: 'WEEK' },
  { label: 'per month', value: 'MONTH' },
]

// Formats an ISO 8601 purchase-to-expiration duration such as 'P6M' or 'P1Y',
// the same values lesson packs use for `expirationDuration`.
export const formatExpirationDuration = duration => {
  const match = /^P(?:(\d+)Y)?(?:(\d+)M)?$/.exec(duration || '')
  if (!match || (!match[1] && !match[2])) return 'Does not expire'
  const [, years, months] = match
  const parts = []
  if (years) parts.push(`${years} ${years === '1' ? 'year' : 'years'}`)
  if (months) parts.push(`${months} ${months === '1' ? 'month' : 'months'}`)
  return `Expires ${parts.join(' ')} after purchase`
}

export const formatTurnaround = hours => {
  const option = TURNAROUND_HOURS_OPTIONS.find(opt => opt.value === hours)
  if (option) return option.label
  return hours ? `${hours} hours` : null
}

// The description editor imports markdown with `preserveNewlines`, which turns
// every blank line into an empty block. Headings are followed directly by
// their list so no empty block sits between them.
export const VIRTUAL_COACHING_TEMPLATE = {
  title: 'Virtual Swing Analysis',
  description:
    "Send me a video of your swing and I'll review it and send back personalized video feedback and a simple plan to improve.\n\n**What to send**\n- A face-on video and a down-the-line video\n- One full swing per angle, about 15 seconds, from address through finish\n- Camera at hip height, with your full body and the club in frame\n\n**What you'll get**\n- A recorded analysis with a focus on the one thing that will help most\n- A clear next step to practice",
  turnaroundHours: DEFAULT_TURNAROUND_HOURS,
}

export const VIRTUAL_COACHING_LEGAL_CAPTION =
  'Virtual coaching is offered to coaches as a convenience. It is the individual coach’s responsibility to set clear expectations for the instruction included and the turnaround time.'
